import { useEffect, useState } from "react";

import api from "../../services/api";

// Qual versão do sistema está no ar.
//
// Uma chamada por sessão: o servidor só muda de versão quando alguém faz o
// deploy, e aí a tela é recarregada de qualquer jeito. O cache no módulo evita
// que cada lugar que mostra a versão peça de novo.
let cache = null;
let pedido = null;

const buscar = () => {
  if (cache) return Promise.resolve(cache);

  if (!pedido) {
    pedido = api
      .get("/version")
      .then(({ data }) => {
        cache = data;
        return cache;
      })
      .catch(() => {
        // Versão é informação de rodapé: se não vier, a tela segue sem ela.
        pedido = null;
        return null;
      });
  }

  return pedido;
};

const useVersao = () => {
  const [versao, setVersao] = useState(cache);

  useEffect(() => {
    let vivo = true;

    buscar().then((dados) => {
      if (vivo) setVersao(dados);
    });

    return () => {
      vivo = false;
    };
  }, []);

  return versao;
};

export default useVersao;
